
import { Component, Constants_maxIssieBusWidth, CustomComponentType, Memory1, shifterWidthFor, ComponentType } from "./CommonTypes.js";
import { filter, fold, map, empty as empty_1, singleton, ofArray, length, mapIndexed } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { op_UnaryNegation, op_LeftShift, op_Subtraction, fromOne, fromInt32, fromZero, toString } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { toList, empty, add } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { evaluateParamExpression, ParamConstraint, tryIntOfParamInt, ParamExpression, ParamName } from "./ParameterTypes.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { equals, compare } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { warn } from "../Shared/Log.js";
import { concat } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { max } from "../fable_modules/fable-library-js.5.13.0/Double.js";

function withMemory(f, compType) {
    switch (compType.tag) {
        case 40:
            return new ComponentType(/* ROM1 */ 40, [f(compType.fields[0])]);
        case 41:
            return new ComponentType(/* RAM1 */ 41, [f(compType.fields[0])]);
        case 39:
            return new ComponentType(/* AsyncROM1 */ 39, [f(compType.fields[0])]);
        case 42:
            return new ComponentType(/* AsyncRAM1 */ 42, [f(compType.fields[0])]);
        default:
            return undefined;
    }
}

function trySetIntSlotValue(slot, value, compType) {
    let idx, idx_1;
    let matchResult, cv, dt, cv_1, lsb, cv_2, dt_1, cv_3, op, st, dv, dv_1, n_2, n_3, w, w_1, w_2, idx_2, lsbs_2, n_4, widths_2, idx_3, lsbs_3, n_5, widths_3;
    switch (slot.tag) {
        case 0: {
            switch (compType.tag) {
                case 2: {
                    matchResult = 0;
                    break;
                }
                case 5: {
                    matchResult = 1;
                    cv = compType.fields[1];
                    dt = compType.fields[2];
                    break;
                }
                case 47: {
                    matchResult = 2;
                    cv_1 = compType.fields[1];
                    break;
                }
                case 6: {
                    matchResult = 3;
                    lsb = compType.fields[1];
                    break;
                }
                case 7: {
                    matchResult = 4;
                    cv_2 = compType.fields[1];
                    dt_1 = compType.fields[2];
                    break;
                }
                case 49: {
                    matchResult = 5;
                    cv_3 = compType.fields[1];
                    break;
                }
                case 17: {
                    matchResult = 6;
                    break;
                }
                case 18: {
                    matchResult = 7;
                    break;
                }
                case 19: {
                    matchResult = 8;
                    break;
                }
                case 20: {
                    matchResult = 9;
                    break;
                }
                case 21: {
                    matchResult = 10;
                    op = compType.fields[1];
                    break;
                }
                case 22: {
                    matchResult = 11;
                    break;
                }
                case 23: {
                    matchResult = 12;
                    break;
                }
                case 24: {
                    matchResult = 13;
                    break;
                }
                case 25: {
                    matchResult = 14;
                    break;
                }
                case 28: {
                    matchResult = 15;
                    break;
                }
                case 33: {
                    matchResult = 16;
                    break;
                }
                case 34: {
                    matchResult = 17;
                    break;
                }
                case 35: {
                    matchResult = 18;
                    break;
                }
                case 36: {
                    matchResult = 19;
                    break;
                }
                case 37: {
                    matchResult = 20;
                    break;
                }
                case 38: {
                    matchResult = 21;
                    break;
                }
                case 46: {
                    matchResult = 22;
                    st = compType.fields[2];
                    break;
                }
                case 48: {
                    matchResult = 23;
                    break;
                }
                case 0: {
                    matchResult = 24;
                    dv = compType.fields[1];
                    break;
                }
                case 1: {
                    matchResult = 25;
                    break;
                }
                default:
                    matchResult = 39;
            }
            break;
        }
        case 1: {
            switch (compType.tag) {
                case 0: {
                    matchResult = 26;
                    dv_1 = compType.fields[1];
                    break;
                }
                case 1: {
                    matchResult = 27;
                    break;
                }
                case 50: {
                    matchResult = 28;
                    break;
                }
                case 51: {
                    matchResult = 29;
                    break;
                }
                case 52: {
                    matchResult = 30;
                    n_2 = compType.fields[1];
                    break;
                }
                case 53: {
                    matchResult = 31;
                    n_3 = compType.fields[1];
                    break;
                }
                case 6: {
                    matchResult = 34;
                    w_2 = compType.fields[0];
                    break;
                }
                default:
                    matchResult = 39;
            }
            break;
        }
        case 8: {
            switch (compType.tag) {
                case 52: {
                    matchResult = 32;
                    w = compType.fields[0];
                    break;
                }
                case 53: {
                    matchResult = 33;
                    w_1 = compType.fields[0];
                    break;
                }
                default:
                    matchResult = 39;
            }
            break;
        }
        case 6: {
            matchResult = 35;
            break;
        }
        case 7: {
            matchResult = 36;
            break;
        }
        case 3: {
            if (compType.tag === 30) {
                if ((idx = (slot.fields[0] | 0), (idx >= 0) && (idx < length(compType.fields[1])))) {
                    matchResult = 37;
                    idx_2 = slot.fields[0];
                    lsbs_2 = compType.fields[2];
                    n_4 = compType.fields[0];
                    widths_2 = compType.fields[1];
                }
                else {
                    matchResult = 39;
                }
            }
            else {
                matchResult = 39;
            }
            break;
        }
        case 4: {
            if (compType.tag === 30) {
                if ((idx_1 = (slot.fields[0] | 0), (idx_1 >= 0) && (idx_1 < length(compType.fields[2])))) {
                    matchResult = 38;
                    idx_3 = slot.fields[0];
                    lsbs_3 = compType.fields[2];
                    n_5 = compType.fields[0];
                    widths_3 = compType.fields[1];
                }
                else {
                    matchResult = 39;
                }
            }
            else {
                matchResult = 39;
            }
            break;
        }
        default:
            matchResult = 39;
    }
    switch (matchResult) {
        case 0:
            return new ComponentType(/* Viewer */ 2, [value]);
        case 1:
            return new ComponentType(/* BusCompare1 */ 5, [value, cv, dt]);
        case 2:
            return new ComponentType(/* BusCompare */ 47, [value, cv_1]);
        case 3:
            return new ComponentType(/* BusSelection */ 6, [value, lsb]);
        case 4:
            return new ComponentType(/* Constant1 */ 7, [value, cv_2, dt_1]);
        case 5:
            return new ComponentType(/* Constant */ 49, [value, cv_3]);
        case 6:
            return new ComponentType(/* NbitsAdder */ 17, [value]);
        case 7:
            return new ComponentType(/* NbitsAdderNoCin */ 18, [value]);
        case 8:
            return new ComponentType(/* NbitsAdderNoCout */ 19, [value]);
        case 9:
            return new ComponentType(/* NbitsAdderNoCinCout */ 20, [value]);
        case 10:
            return new ComponentType(/* NbitsXor */ 21, [value, op]);
        case 11:
            return new ComponentType(/* NbitsAnd */ 22, [value]);
        case 12:
            return new ComponentType(/* NbitsNot */ 23, [value]);
        case 13:
            return new ComponentType(/* NbitsOr */ 24, [value]);
        case 14:
            return new ComponentType(/* NbitSpreader */ 25, [value]);
        case 15:
            return new ComponentType(/* SplitWire */ 28, [value]);
        case 16:
            return new ComponentType(/* Register */ 33, [value]);
        case 17:
            return new ComponentType(/* RegisterE */ 34, [value]);
        case 18:
            return new ComponentType(/* Counter */ 35, [value]);
        case 19:
            return new ComponentType(/* CounterNoLoad */ 36, [value]);
        case 20:
            return new ComponentType(/* CounterNoEnable */ 37, [value]);
        case 21:
            return new ComponentType(/* CounterNoEnableLoad */ 38, [value]);
        case 22:
            return new ComponentType(/* Shift */ 46, [value, shifterWidthFor(value), st]);
        case 23:
            return new ComponentType(/* Input */ 48, [value]);
        case 24:
            return new ComponentType(/* Input1 */ 0, [value, dv]);
        case 25:
            return new ComponentType(/* Output */ 1, [value]);
        case 26:
            return new ComponentType(/* Input1 */ 0, [value, dv_1]);
        case 27:
            return new ComponentType(/* Output */ 1, [value]);
        case 28:
            return new ComponentType(/* BusOut */ 50, [value]);
        case 29:
            return new ComponentType(/* MuxOut */ 51, [value]);
        case 30:
            return new ComponentType(/* JoinOut */ 52, [value, n_2]);
        case 31:
            return new ComponentType(/* JoinIn */ 53, [value, n_3]);
        case 32:
            return new ComponentType(/* JoinOut */ 52, [w, value]);
        case 33:
            return new ComponentType(/* JoinIn */ 53, [w_1, value]);
        case 34:
            return new ComponentType(/* BusSelection */ 6, [w_2, value]);
        case 35:
            return withMemory((mem) => (new Memory1(mem.Init, value, mem.WordWidth, mem.Data, mem.Comments)), compType);
        case 36:
            return withMemory((mem_1) => (new Memory1(mem_1.Init, mem_1.AddressWidth, value, mem_1.Data, mem_1.Comments)), compType);
        case 37:
            return new ComponentType(/* SplitN */ 30, [n_4, mapIndexed((i, w_3) => {
                if (i === idx_2) {
                    return value | 0;
                }
                else {
                    return w_3 | 0;
                }
            }, widths_2), lsbs_2]);
        case 38:
            return new ComponentType(/* SplitN */ 30, [n_5, widths_3, mapIndexed((i_1, l) => {
                if (i_1 === idx_3) {
                    return value | 0;
                }
                else {
                    return l | 0;
                }
            }, lsbs_3)]);
        default:
            return undefined;
    }
}

/**
 * The type with `value` put into the named slot, or None when the component has no such slot.
 * 
 * `Buswidth` is a component's own width. `IO` is the width of an Input or an Output - and also
 * the LSB of a BusSelection and the comparison value of a BusCompare, because on those two the
 * width has already taken `Buswidth` and the properties pane needs a second slot for a second
 * field (see SelectedComponentView.makeLsbBitNumberField). That overloading is unfortunate but
 * it is what is stored in existing sheets.
 * 
 * Some integers of a component are deliberately absent, because a parameter records a value and
 * not a change of shape:
 * - the input count of a GateN or a MergeN sets how many ports the component has, so there is
 * no CompSlotName for it and neither component can be parameterised at all;
 * - the output count of a SplitN is the same thing, so it has no slot - but the width and the
 * bit position of a GIVEN output are ordinary values, and SplitNWidth/SplitNLSB name them.
 * Those two are the only slots that can be out of range, and an index past the end of the
 * lists is no slot rather than a silently ignored one.
 * 
 * This is the one place a parameter value stops being a bigint. The three slots whose field is
 * already a bigint take it as it is - which is why parameter expressions evaluate in bigint at
 * all - and everything else is a width, an index or a bit position, and is narrowed here. A value
 * too large to be an int is no more applicable than a slot the component does not have, so it
 * comes back as None; it should have been stopped by the slot's own constraint before reaching
 * here, so the warning says that it was not.
 */
export function trySetSlotValue(slot, value, compType) {
    let matchResult, w, w_1, w_2, w_3, cc, paramName;
    switch (slot.tag) {
        case 1: {
            switch (compType.tag) {
                case 47: {
                    matchResult = 0;
                    w = compType.fields[0];
                    break;
                }
                case 7: {
                    matchResult = 2;
                    w_2 = compType.fields[0];
                    break;
                }
                case 5: {
                    matchResult = 3;
                    w_3 = compType.fields[0];
                    break;
                }
                default:
                    matchResult = 5;
            }
            break;
        }
        case 5: {
            if (compType.tag === 0) {
                matchResult = 1;
                w_1 = compType.fields[0];
            }
            else {
                matchResult = 5;
            }
            break;
        }
        case 2: {
            if (compType.tag === 26) {
                matchResult = 4;
                cc = compType.fields[0];
                paramName = slot.fields[0];
            }
            else {
                matchResult = 5;
            }
            break;
        }
        default:
            matchResult = 5;
    }
    switch (matchResult) {
        case 0:
            return new ComponentType(/* BusCompare */ 47, [w, value]);
        case 1:
            return new ComponentType(/* Input1 */ 0, [w_1, value]);
        case 2:
            return new ComponentType(/* Constant1 */ 7, [w_2, value, toString(value)]);
        case 3:
            return new ComponentType(/* BusCompare1 */ 5, [w_3, value, toString(value)]);
        case 4:
            return new ComponentType(/* Custom */ 26, [new CustomComponentType(cc.Name, cc.InputLabels, cc.OutputLabels, cc.Form, add(new ParamName(paramName), new ParamExpression(/* PInt */ 0, [value]), defaultArg(cc.ParameterBindings, empty({
                Compare: (x, y) => (compare(x, y) | 0),
            }))), cc.Description)]);
        default: {
            const matchValue_1 = tryIntOfParamInt(value);
            if (matchValue_1 == null) {
                warn(`Parameter value ${value} is too large for slot ${slot}, which holds a whole number: the component is unchanged`);
                return undefined;
            }
            else {
                return trySetIntSlotValue(slot, matchValue_1, compType);
            }
        }
    }
}

/**
 * True when the component has the named slot, so that a slot can be rejected where it is written
 * rather than quietly doing nothing where it is applied. The value is irrelevant: whether a slot
 * exists depends on the component's type and, for a SplitN output, on the index.
 */
export function slotApplies(slot, compType) {
    return trySetSlotValue(slot, fromZero(), compType) != null;
}

/**
 * The bounds a value must satisfy to be written into this slot of this component.
 * 
 * The other half of the mapping trySetSlotValue owns, and here for the same reason: what a slot
 * IS includes what may go in it, and the two kept apart is how they drifted. They were built
 * inline at each properties box instead, which had two consequences:
 * 
 * - a bound computed from the component's width was frozen at the width the box was showing
 * when the expression was typed. Parameterise the width, change the parameter, and an Input's
 * stored "must fit in 8 bits" outlived the 8;
 * - a value that arrived any other way was bounded by nothing. maxIssieBusWidth was enforced
 * only by these lists, so a width bound to a parent's parameter, or written by the sheet
 * description DSL, had no upper limit at all and the first thing to object was the simulator.
 * 
 * Derived, so it cannot go stale: every caller asks about the component as it is now. The
 * Constraints stored on a slot are still written as they were, for file compatibility, but are no
 * longer what a value is checked against.
 * 
 * The messages are the ones the boxes used to build, and are written for whoever typed the value:
 * see ParameterView.evaluateConstraints, which hands the author's text straight to the user.
 */
export function constraintsFor(slot, compType) {
    const maxWidth = fromInt32(Constants_maxIssieBusWidth);
    const widthConstraints = (what) => ofArray([new ParamConstraint(/* MinVal */ 0, [new ParamExpression(/* PInt */ 0, [fromOne()]), concat(what, " must be positive")]), new ParamConstraint(/* MaxVal */ 1, [new ParamExpression(/* PInt */ 0, [maxWidth]), `${what} cannot exceed ${Constants_maxIssieBusWidth}`])]);
    const fitsIn = (what_1, width) => ofArray([new ParamConstraint(/* MinVal */ 0, [new ParamExpression(/* PInt */ 0, [fromZero()]), concat(what_1, " must be non-negative")]), new ParamConstraint(/* MaxVal */ 1, [new ParamExpression(/* PInt */ 0, [op_Subtraction(op_LeftShift(fromOne(), width), fromOne())]), `${what_1} must fit in ${width} bits`])]);
    const fitsWidth = (what_2, width_1) => {
        const bits = max(1, width_1) | 0;
        return ofArray([new ParamConstraint(/* MinVal */ 0, [new ParamExpression(/* PInt */ 0, [op_UnaryNegation(op_LeftShift(fromOne(), bits - 1))]), `${what_2} must be at least ${op_UnaryNegation(op_LeftShift(fromOne(), bits - 1))} in ${bits} bits`]), new ParamConstraint(/* MaxVal */ 1, [new ParamExpression(/* PInt */ 0, [op_Subtraction(op_LeftShift(fromOne(), bits), fromOne())]), `${what_2} must fit in ${bits} bits`])]);
    };
    const matchValue = slotApplies(slot, compType);
    if (matchValue) {
        let matchResult, width_2, width_3, width_4, width_5;
        switch (slot.tag) {
            case 1: {
                switch (compType.tag) {
                    case 6: {
                        matchResult = 0;
                        break;
                    }
                    case 47: {
                        matchResult = 1;
                        width_2 = compType.fields[0];
                        break;
                    }
                    case 5: {
                        matchResult = 2;
                        width_3 = compType.fields[0];
                        break;
                    }
                    case 7: {
                        matchResult = 3;
                        width_4 = compType.fields[0];
                        break;
                    }
                    case 28: {
                        matchResult = 11;
                        break;
                    }
                    case 25: {
                        matchResult = 12;
                        break;
                    }
                    default:
                        matchResult = 13;
                }
                break;
            }
            case 5: {
                switch (compType.tag) {
                    case 0: {
                        matchResult = 4;
                        width_5 = compType.fields[0];
                        break;
                    }
                    case 28: {
                        matchResult = 11;
                        break;
                    }
                    case 25: {
                        matchResult = 12;
                        break;
                    }
                    default:
                        matchResult = 13;
                }
                break;
            }
            case 2: {
                matchResult = 5;
                break;
            }
            case 6: {
                matchResult = 6;
                break;
            }
            case 7: {
                matchResult = 7;
                break;
            }
            case 8: {
                matchResult = 8;
                break;
            }
            case 3: {
                matchResult = 9;
                break;
            }
            case 4: {
                matchResult = 10;
                break;
            }
            default:
                switch (compType.tag) {
                    case 28: {
                        matchResult = 11;
                        break;
                    }
                    case 25: {
                        matchResult = 12;
                        break;
                    }
                    default:
                        matchResult = 13;
                }
        }
        switch (matchResult) {
            case 0:
                return singleton(new ParamConstraint(/* MinVal */ 0, [new ParamExpression(/* PInt */ 0, [fromZero()]), "LSB position must be non-negative"]));
            case 1:
                return fitsIn("Comparison value", width_2);
            case 2:
                return fitsWidth("Comparison value", width_3);
            case 3:
                return fitsWidth("Constant value", width_4);
            case 4:
                return fitsIn("Default value", width_5);
            case 5:
                return empty_1();
            case 6:
                return widthConstraints("Address width");
            case 7:
                return widthConstraints("Word width");
            case 8:
                return singleton(new ParamConstraint(/* MinVal */ 0, [new ParamExpression(/* PInt */ 0, [fromZero()]), "Channel number must be non-negative"]));
            case 9:
                return widthConstraints("Width");
            case 10:
                return ofArray([new ParamConstraint(/* MinVal */ 0, [new ParamExpression(/* PInt */ 0, [fromZero()]), "LSB must be non-negative"]), new ParamConstraint(/* MaxVal */ 1, [new ParamExpression(/* PInt */ 0, [maxWidth]), `LSB cannot exceed ${Constants_maxIssieBusWidth}`])]);
            case 11:
                return widthConstraints("Top (LSB) output width");
            case 12:
                return widthConstraints("Output width");
            default:
                return widthConstraints("Width");
        }
    }
    else {
        return empty_1();
    }
}

/**
 * Apply `value` to the named slot, leaving the type alone where the component has no such slot.
 * Callers that can report a bad slot should use trySetSlotValue; this is for the paths that
 * cannot, where a slot recorded in an old file must not stop a sheet loading or simulating.
 */
export function setSlotValue(slot, value, compType) {
    return defaultArg(trySetSlotValue(slot, value, compType), compType);
}

/**
 * A sheet's canvas with every parameterised slot resolved at the given bindings.
 * A slot whose expression cannot be evaluated leaves its component alone, so the widths that are
 * known still come out rather than the whole sheet failing.
 * 
 * Here rather than in CanvasExtractor because two callers need it from opposite ends of the
 * compile order: the instance-signature code in CanvasExtractor, and the parameter propagation in
 * ParameterAnalysis that brings every sheet into line with what its design sets.
 */
export function resolveCanvasAtBindings(bindings, slots, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    return [map((comp) => (new Component(comp.Id, fold((compType, tupledArg_1) => {
        const matchValue = evaluateParamExpression(bindings, tupledArg_1[1].Expression);
        if (matchValue.tag === 1) {
            return compType;
        }
        else {
            return setSlotValue(tupledArg_1[0].CompSlot, matchValue.fields[0], compType);
        }
    }, comp.Type, filter((tupledArg) => equals(tupledArg[0].CompId, comp.Id), toList(slots))), comp.Label, comp.InputPorts, comp.OutputPorts, comp.X, comp.Y, comp.H, comp.W, comp.SymbolInfo, comp.SlotInfo)), _arg[0]), _arg[1]];
}

